import React from "react";
import { Link } from "react-router-dom";
import AuthContext from "../context/AuthContext";
import { useContextSelector } from "use-context-selector";

const LanguageSelect = ({ setLanguage }) => {
  const lang = useContextSelector(AuthContext, (ctx) => {
    return ctx.lang;
  });
  const changeLanguage = useContextSelector(AuthContext, (ctx) => {
    return ctx.changeLanguage;
  });
  return (
    <app-language
      _ngcontent-serverapp-c3873775662
      _nghost-serverapp-c3044725087
      className="ng-tns-c3044725087-109 ng-star-inserted"
    >
      <div
        _ngcontent-serverapp-c3044725087
        className="pop-wrap pop-language ng-tns-c3044725087-109 ng-trigger ng-trigger-popWrapTriggerAni show ani ng-star-inserted"
      >
        <div
          _ngcontent-serverapp-c3044725087
          className="pop-title ng-tns-c3044725087-109"
        >
          <h3
            _ngcontent-serverapp-c3044725087
            className="ng-tns-c3044725087-109"
          >
            Currency and Language
          </h3>
          <Link
            to="/"
            onClick={() => setLanguage(false)}
            _ngcontent-serverapp-c3044725087
            className="btn-close ng-tns-c3044725087-109"
            style={{
              "mask-image": 'url("/assets/Other/icon-close.svg")',
            }}
          />
        </div>
        <div
          _ngcontent-serverapp-c3044725087
          className="pop-inner ng-tns-c3044725087-109"
        >
          <ul
            _ngcontent-serverapp-c3044725087
            className="language-list ng-tns-c3044725087-109 ng-star-inserted"
            style={{}}
          >
            <li
              _ngcontent-serverapp-c3044725087
              className="ng-tns-c3044725087-109 ng-star-inserted"
            >
              <div
                _ngcontent-serverapp-c3044725087
                className="left-language-area ng-tns-c3044725087-109"
              >
                <img
                  _ngcontent-serverapp-c3044725087
                  className="ng-tns-c3044725087-109"
                  alt="BDT"
                  src={"/assets/Other/BD.png"}
                  loading="lazy"
                />
                <p
                  _ngcontent-serverapp-c3044725087
                  className="ng-tns-c3044725087-109"
                >
                  <span
                    _ngcontent-serverapp-c3044725087
                    className="ng-tns-c3044725087-109 ng-star-inserted"
                  >
                    ৳
                  </span>
                  BDT{" "}
                </p>
              </div>
              <div
                _ngcontent-serverapp-c3044725087
                className="right-language-area ng-tns-c3044725087-109"
              >
                <ul
                  _ngcontent-serverapp-c3044725087
                  className="radio-box ng-tns-c3044725087-109"
                >
                  <li
                    onClick={(e) => changeLanguage("en")}
                    _ngcontent-serverapp-c3044725087
                    name="language"
                    className={`ng-tns-c3044725087-109 ${
                      lang == "en" ? "active" : ""
                    } ng-star-inserted`}
                    id="BDT0"
                  >
                    {" "}
                    English{" "}
                  </li>
                  <li
                    onClick={(e) => changeLanguage("bn")}
                    _ngcontent-serverapp-c3044725087
                    name="language"
                    className={`ng-tns-c3044725087-109 ${
                      lang == "bn" ? "active" : ""
                    } ng-star-inserted`}
                    id="BDT1"
                  >
                    {" "}
                    বাংলা{" "}
                  </li>
                </ul>
              </div>
            </li>
          </ul>
        </div>
      </div>

      <div
        _ngcontent-serverapp-c3044725087
        className="pop-bg ng-tns-c3044725087-109 ng-trigger ng-trigger-popBgTriggerAni ng-star-inserted"
        style={{ display: "block" }}
      />
    </app-language>
  );
};

export default LanguageSelect;
